<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="contract" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "contract-view-logs",

  components: { LogListTable },

  props: ["contract"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
